export default "/images/vendor/flag-icon-css/flags/1x1/um.svg?c3e06b4d7dfec14653ce49da7ac9efe4";